import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { Router, RouterLink } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DatasearchService } from '../../_services/datasearch.service';
import { AuthenticationService } from '../../_services/authentication.service';
import { CommonModule, NgIf } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-change-pswd',
  standalone: true,
  imports: [HeaderComponent,
    FooterComponent,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,NgIf,CommonModule],
  templateUrl: './change-pswd.component.html',
  styleUrl: './change-pswd.component.scss'
})
export class ChangePswdComponent {
  pswdForm: FormGroup = this.fb.group({});
  user_data: any = {};
  alertVisible: boolean = false;

  constructor(private fb: FormBuilder, private datasearch: DatasearchService,private router: Router,private authenticationService: AuthenticationService,) { }
  
  ngOnInit() {

    this.initPasswordForm();
    this.getdata();
  }
  initPasswordForm() {
    this.pswdForm = this.fb.group({
      oldpassword: ['', Validators.required],
      newpassword: ['', Validators.required],
      cpassword: ['', Validators.required]
    });
  }
  getdata() {
    const currentUserdata = JSON.parse(localStorage.getItem('currentUser') || '{}');
    // Ensure currentUserdata and email are defined
    if (!currentUserdata || !currentUserdata.email) {
      // console.error('User data is missing or email is not available');
      return;
    }
    const email = currentUserdata.email;
  
    const postdata = {
      keyword: email
    };
  
    this.datasearch.getUserprofile(postdata).subscribe(
      (res) => {
        this.user_data = res.data;
      },
      (err) => {
        // console.error('Error fetching user data:', err);
      }
    );
  }
  updatePassword(): void {
    let postdata: any = this.pswdForm.value;
  
    for (let key in this.user_data) {
      if (!(key in postdata)) {
        postdata[key] = this.user_data[key];
      }
    }
  
    this.datasearch.sendChngepswd(postdata).subscribe(
      (response: any) => {
        if (response.status === 'success') {
          this.initPasswordForm();
          // console.log('Update successful, showing alert.');
          this.showSuccessAlert();
        }
      },
      (error) => {
        console.error(error); // Handle error response
      }
    );
  }
  
  showSuccessAlert(): void {
    this.alertVisible = true;
    setTimeout(() => this.closeAlert(), 5000); // Hide alert after 5 seconds
  }

  closeAlert(): void {
    this.alertVisible = false;
  }
  LogoutClick() {
    this.authenticationService.logout();
    // console.log('Logout clicked');
    this.closeSignoutModal();
    
    const currentRoute = this.router.url;
    const routesToRedirect = ['/profile', '/edit_profile', '/change_password'];
  
    if (routesToRedirect.includes(currentRoute)) {
      this.router.navigate(['/home']);
    }
  }
  closeSignoutModal() {
    const modalElement = document.getElementById('signOutModal');
    if (modalElement) {
      $('#signOutModal').modal('hide');

    }
  }
}
